import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { IMG, goTo } from "@/components/home/homeData";
import { EmailSetupButton } from "@/components/home/EmailCta";
import { LandingVisual } from "./LandingVisual";

export const LandingHero = ({ page, onStart }) => (
  <section className="relative bg-[#0B1120] text-white overflow-hidden home-noise" data-testid="landing-hero">
    <div className="absolute inset-0 home-grid" />
    <div className="absolute inset-y-0 right-0 w-full lg:w-[62%] bg-cover bg-center opacity-40" style={{ backgroundImage: `url(${IMG.hero})` }} />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0B1120] via-[#0B1120]/90 to-[#0B1120]/30" />
    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 pb-24 lg:pb-32 grid lg:grid-cols-[1fr_1.05fr] gap-14 lg:gap-12 items-center">
      <div>
        <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} data-testid="landing-eyebrow"
          className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-semibold text-slate-200">
          <span className="w-2 h-2 rounded-full bg-[#EA580C]" /> {page.eyebrow}
        </motion.p>
        <motion.h1 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 }} data-testid="landing-title"
          className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">{page.h1}</motion.h1>
        <motion.p initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.16 }} data-testid="landing-intro"
          className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed max-w-xl">{page.intro}</motion.p>
        <ul className="mt-7 grid gap-2.5" data-testid="landing-points">
          {page.points.map((p) => <li key={p} className="flex items-center gap-2.5 text-sm sm:text-base font-semibold"><Check className="w-4 h-4 text-[#EA580C]" />{p}</li>)}
        </ul>
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.24 }} className="mt-9 flex flex-wrap gap-3">
          <EmailSetupButton testid="landing-email-btn" />
          <button onClick={onStart} data-testid="landing-start-btn"
            className="rounded-full border border-white/25 px-6 py-3.5 font-semibold text-white hover:bg-white hover:text-[#0B1120] transition-colors">
            Start free trial
          </button>
        </motion.div>
        <p className="mt-6 text-sm text-slate-400">
          <button onClick={() => goTo("pricing")} data-testid="landing-pricing-btn" className="font-semibold text-white underline-offset-4 hover:underline">See pricing</button>
          <span className="mx-2">·</span>Already on Cross Jobs? <Link to="/login" data-testid="landing-signin-link" className="font-semibold text-white underline-offset-4 hover:underline">Sign in</Link>
        </p>
      </div>
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.7 }} className="relative lg:pl-6" data-testid="landing-visual">
        <LandingVisual page={page} />
      </motion.div>
    </div>
  </section>
);
